// Veteran appreciation discount. The offer (code, %, eligible offers, on/off,
// and whether a quick service verification is required) is controlled by the owner
// in Admin → Settings → Veteran Discount and served from the backend.
import { useState, useEffect } from "react";
import api from "@/lib/api";

export const VETERAN_DISCOUNT_PCT = 15;
export const VETERAN_DISCOUNT_CODE = "SALUTE15";

const STORE_KEY = "atf_vet_discount";

export function getVerifiedDiscount() {
  try { return JSON.parse(localStorage.getItem(STORE_KEY) || "null"); } catch { return null; }
}
export function setVerifiedDiscount(d) {
  try { d ? localStorage.setItem(STORE_KEY, JSON.stringify(d)) : localStorage.removeItem(STORE_KEY); } catch { /* ignore */ }
}

let _cache = null;

export function useVeteranDiscount() {
  const [cfg, setCfg] = useState(_cache);
  useEffect(() => {
    if (_cache) { setCfg(_cache); return; }
    let alive = true;
    api.get("/veteran-discount")
      .then((r) => { _cache = r.data; if (alive) setCfg(r.data); })
      .catch(() => {});
    return () => { alive = false; };
  }, []);
  return cfg;
}
